import React, {
  CSSProperties,
  FC,
  LinkHTMLAttributes,
  MouseEvent,
} from "react";
import NextLink from "next/link";

interface Props extends LinkHTMLAttributes<any> {
  id?: string;
  className?: string;
  style?: CSSProperties;
  href: string;
  onClick?: (event: MouseEvent<HTMLElement, Event>) => void | Promise<void>;
  onMouseEnter?: (
    event: MouseEvent<HTMLElement, Event>
  ) => void | Promise<void>;
  onMouseLeave?: (
    event: MouseEvent<HTMLElement, Event>
  ) => void | Promise<void>;
  theme?: "white" | "blue" | "black";
  fill?: "full" | "outline";
  download?: boolean;
  target?: "_blank" | "_self";
  noStyle?: boolean;
  title?: string;
}

export const Link: FC<Props> = (props) => {
  if (
    props.href &&
    (props.href.startsWith("http") ||
      props.href.startsWith("mailto") ||
      props.href.startsWith("tel"))
  ) {
    return (
      <a
        href={props.href}
        id={props.id}
        style={props.style}
        download={props.download}
        target={props.target || "_self"}
        className={`${!props.noStyle ? "link" : ""} ${
          props.theme ? "link_" + props.theme : ""
        } ${props.fill ? "link_" + props.fill : ""} ${props.className || ""}`}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
        data-title={props.title}
      >
        {props.children}
      </a>
    );
  }
  return (
    <NextLink
      href={props.href}
      className={`${!props.noStyle ? "link" : ""} ${
        props.theme ? "link_" + props.theme : ""
      } ${props.fill ? "link_" + props.fill : ""} ${props.className || ""}`}
      style={props.style}
      id={props.id}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      data-title={props.title}
    >
      {props.children}
    </NextLink>
  );
};
